module.exports = __webpack_public_path__ + "static/media/excel2.fff8d376.PNG";